export default __webpack_public_path__ + "static/media/diagnostiqueActual.49c0309c.png";